import axios from "axios";
import { apiUrl } from "../api/enviroment";
import { ApiRoutes } from "../api/api_routes";
import TokenManager from "../token_manager";

const prefacturaController = {
  async getFacturas() {
    const token = TokenManager.getToken();
    const url = `${apiUrl}/${ApiRoutes.preFacturaGetAll}`;

    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        return { ok: false };
      }
    } catch (error) {
      return { ok: false, error: error.message };
    }
  },
  async submitFacturasDocuments(payload) {
    const token = TokenManager.getToken();
    const url = `${apiUrl}/${ApiRoutes.setFacturaIndicacion}`;

    try {
      const response = await axios.post(url, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        return response.data;
      } else {
        return { ok: false };
      }
    } catch (error) {
      return { ok: false, error: error.message };
    }
  },
  async getPruebas() {
    const token = TokenManager.getToken();
    const url = `${apiUrl}/${ApiRoutes.getPrefacturaPruebas}`;
    try {
      const response = await axios.post(
        url,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return { ok: false };
      }
    } catch (error) {
      return { ok: false, error: error.message };
    }
  },
};

export default prefacturaController;
